






























































































import Vue from "vue";
import TableLayout from "@/layouts/TableLayout.vue";
import { Header } from "../components/MyTable.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import Edit from "@/components/PrjService/Edit.vue";
import Info from "@/components/PrjService/Info.vue";
import { eventBus } from "../utils/event";

const TableHeaders: Header[] = [
  { title: "名称", key: "", width: 200 },
  { title: "服务类型", key: "", width: 120 },
  { title: "负载类型", key: "", width: 120 },
  { title: "组件名称", key: "", width: 160 },
  { title: "开启会话保持", key: "", width: 120 },
  { title: "服务IP", key: "", width: 150 },
  { title: "端口", key: "", width: 300 },
  { title: "创建时间", key: "createTime", width: 190 },
  { title: "操作", key: "", width: 100 }
];

export default Vue.extend({
  name: "PrjService",
  components: { TableLayout, Edit, Info },
  props: { projectId: { type: String } },
  data() {
    return {
      value: "",
      disabled: false,
      TableHeaders,
      showTools: true
    };
  },
  computed: {
    ...mapState("PrjService", ["total", "hasNext", "pageNum", "loading"]),
    ...mapGetters("PrjService", ["tableData"])
  },
  mounted() {
    this.getTable();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("PrjService", [
      "getData",
      "pageTurn",
      "clear",
      "filterSearch",
      "delete"
    ]),
    create(data: any) {
      (this.$refs.edit as any).show(data);
    },
    getTable() {
      this.getData({
        url: `/service/${this.projectId}`
      });
    },
    del(name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({ url: `/service/${this.projectId}/${name}` }).then(() => {
          this.$message.success("服务删除成功");
        });
      });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    showInfo(data: any) {
      this.showTools = false;
      eventBus.$emit("setBeard", {
        name: "概览",
        callback: () => {
          this.showTools = true;
          (this.$refs.info as any).close();
        }
      });

      (this.$refs.info as any)?.show(data);
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.metadata.name);
          break;
      }
    }
  }
});
